import React from "react";
import Typography from "../../Typography/Typography";

const NodesList = ({
    selectedProject,
    nodes,
    selectedNodes,
    isLoading,
    onNodeToggle,
}) => {
    return (
        <div className="card border-0 shadow-sm h-100">
            <div className="card-header bg-white border-bottom py-3">
                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <i className="bi bi-diagram-3 text-primary me-2"></i>
                        <Typography variant="h5" className="mb-0">
                            Nodes
                        </Typography>
                    </div>
                    {selectedProject && (
                        <span className="badge bg-light text-dark border">
                            {selectedProject?.name || selectedProject?.title}
                        </span>
                    )}
                </div>
            </div>
            <div className="card-body p-0">
                <div
                    className="overflow-auto p-3"
                    style={{ maxHeight: "400px" }}
                >
                    {isLoading ? (
                        <div className="text-center py-4">
                            <div
                                className="spinner-border spinner-border-sm text-primary"
                                role="status"
                            >
                                <span className="visually-hidden">
                                    Loading...
                                </span>
                            </div>
                            <p className="text-muted mt-2 mb-0">
                                Loading nodes...
                            </p>
                        </div>
                    ) : (
                        <>
                            {nodes.length > 0 ? (
                                <div className="d-flex flex-column gap-2">
                                    {nodes.map((node) => (
                                        <NodeItem
                                            key={node.id}
                                            node={node}
                                            selectedProject={selectedProject}
                                            selectedNodes={selectedNodes}
                                            onNodeToggle={onNodeToggle}
                                        />
                                    ))}
                                </div>
                            ) : (
                                <div className="text-center py-4">
                                    <i className="bi bi-diagram-3-fill text-muted fs-3 d-block mb-2"></i>
                                    <p className="text-muted mb-0">
                                        No nodes found for this project
                                    </p>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

// Further breakdown for node item
const NodeItem = ({ node, selectedProject, selectedNodes, onNodeToggle }) => (
    <div className="w-100">
        <div
            className={`card h-100 ${
                selectedNodes[selectedProject?.id]?.includes(node.id)
                    ? "border-primary bg-light bg-opacity-25"
                    : "border"
            }`}
        >
            <div className="card-body p-2">
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id={`node-${node.id}`}
                        checked={
                            selectedNodes[selectedProject?.id]?.includes(
                                node.id,
                            ) || false
                        }
                        onChange={() => onNodeToggle(node.id)}
                    />
                    <label
                        className="form-check-label d-flex align-items-center"
                        htmlFor={`node-${node.id}`}
                    >
                        <Typography
                            variant="body1"
                            className="mb-0 text-truncate"
                        >
                            {node.name}
                        </Typography>
                    </label>
                </div>
            </div>
        </div>
    </div>
);

export default NodesList;
